import React from 'react';
import Slider from "react-slick";



function Testimonial() {

  var settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    arrow: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };


  return (
    <>
     
      <section className="testinomial-container">

        <div className='sec-title'>
          <h2>Testimonial</h2>
          <div class="separator"></div>
        </div>

        <div className='container'>
      <Slider {...settings}>
      <div>
      <div class="eltdf-testimonial-text-holder">
                    <div class="eltdf-testimonials-quotes-holder">
                       ""
                    </div>
                                            <p class="eltdf-testimonial-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua ut enimad minim veniam quis nostrud exerci tation ullamco</p>
                                                                <h6 class="eltdf-testimonial-author">
                                                            <span class="eltdf-testimonials-author-name">Isabel Tillman</span>
                                                    </h6>
                        <div>
                                                            <div class="eltdf-testimonials-author-job">Visitor</div>
                                                    </div>
                                    </div>
      </div>


      <div>
      <div class="eltdf-testimonial-text-holder">
                    <div class="eltdf-testimonials-quotes-holder">
                      ""
                    </div>
                                            <p class="eltdf-testimonial-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua ut enimad minim veniam quis nostrud exerci tation ullamco</p>
                                                                <h6 class="eltdf-testimonial-author">
                                                            <span class="eltdf-testimonials-author-name">Isabel Tillman</span>
                                                    </h6>
                        <div>
                                                            <div class="eltdf-testimonials-author-job">Visitor</div>
                                                    </div>
                                    </div>
      </div>


      <div>
      <div class="eltdf-testimonial-text-holder">
                    <div class="eltdf-testimonials-quotes-holder">
                      ""
                    </div>
                                            <p class="eltdf-testimonial-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua ut enimad minim veniam quis nostrud exerci tation ullamco</p>
                                                                <h6 class="eltdf-testimonial-author">
                                                            <span class="eltdf-testimonials-author-name">Isabel Tillman</span>
                                                    </h6>
                        <div>
                                                            <div class="eltdf-testimonials-author-job">Visitor</div>
                                                    </div>
                                    </div>
      </div>

    
    </Slider>


      </div>
      </section>

    </>
  )

}

export default Testimonial;
